var FIGURE = FIGURE || {};

FIGURE.shippingMessage = function() {
	var specialMessageModal = $.cookie('specialmessage');
	if (specialMessageModal == 'read') {
		return;
	} else {
		setTimeout(function(){
			$('#figureMessageModal').modal();
		}, 3000);	
	}	
	$('#figureMessageModal').on('hide.bs.modal', function (event) {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
	$('#figureMessageModal a').click(function() {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
}();

FIGURE.getLoaded = function() {
	$(document).ready(function() {
		setTimeout(() => {
			$("body").addClass("loaded");

			if ($("body").hasClass("layout-marketing")) {
				const $cols = [$(".col-wine"), $(".col-people"), $(".col-accolade")];
				let windowWidth = $(window).width();
				let inViewPercent = windowWidth < 768 ? .1 : .25; // Adjust delay for smaller screens
				const runLoad = function(inViewPercent) {
					$("section").each((i, section) => {
						if ($(section).hasClass("loaded")) return; // Skip if already loaded
						if (isInView(section, inViewPercent)) {
							$(section).addClass("loaded");
						}
					});
				}
				$(".modal").on("show.bs.modal", function(e){
					let elapsed = 0;
					const interval = setInterval(() => {
						elapsed += 100;
						const $modal = $(e.target).closest(".modal");

						if ($modal.find("section").length) {
							$modal.find("section").addClass("loaded");
							clearInterval(interval); // found it, stop early
						}

						if (elapsed >= 5000) {
							clearInterval(interval); // 5s timeout, give up
						}
					}, 100);
					// setTimeout(() => {
					// 	console.log({target: $(e.target)});
					// 	$(e.target).closest(".modal").addClass("loaded");
					// }, 500);
				})
				runLoad(inViewPercent);
				$(window).on("scroll", function() {
					windowWidth = $(window).width();
					inViewPercent = windowWidth < 768 ? .1 : .25; // Adjust delay for smaller screens
					runLoad(inViewPercent);
					$(".col-md-6 img").each((i, img) => {
						if ($(img).hasClass("loaded")) return; // Skip if already loaded
						if (isInView(img, inViewPercent)) {
							$(img).addClass("loaded");
						}
					});
					$cols.forEach($columns => {
						let colsToLoad = [];
						$($columns).each(function() {
							const $this = $(this);
							if (isInView(this, inViewPercent) && !$this.hasClass('loaded')) {
								colsToLoad.push($this);
							}
							colsToLoad.forEach((col, i) => {
								let colPass = true;
								for (let x = 0; x < 4; x++) {
									if (col.hasClass(`loaded-${x}`)) {
										colPass = false;
										break;
									}
								}
								if (colPass) {
									col.addClass(`loaded-${i}`);
									setTimeout(() => {
										col.addClass("loaded");
									}, 100);
								}
							});
						});
					});
				});
			}
		}, 300)
	});
}();

function isInView(selector, threshold = 0.25) {
	const $section = $(selector);
	if (!$section.length) return false;
	const elementTop = $section.offset().top;
	const elementBottom = elementTop + $section.outerHeight();
	const viewportTop = $(window).scrollTop();
	const viewportBottom = viewportTop + $(window).height();


	// Section must actually be visible first
	const isVisible = (elementBottom > viewportTop) && (elementTop < viewportBottom);
	if (!isVisible) return false;

	// Then check if it's within 25% of viewport height
	const viewportHeight = $(window).height();
	const visibleHeight = Math.min(elementBottom, viewportBottom) - Math.max(elementTop, viewportTop);
	const visiblePercentage = visibleHeight / viewportHeight;

	return visiblePercentage >= threshold
		|| ($section.outerHeight() / viewportHeight < threshold && viewportBottom > elementTop);
}

FIGURE.wineFilter = function() {
	// Function to get URL parameters
	function getUrlParams() {
		const urlParams = new URLSearchParams(window.location.search);
		return {
			collection: urlParams.get('collection') || 'all',
			vintage: urlParams.get('vintage') || 'all'
		};
	}

	// Function to update URL parameters
	function updateUrlParams(collection, vintage) {
		const url = new URL(window.location);

		if (collection === 'all') {
			url.searchParams.delete('collection');
		} else {
			url.searchParams.set('collection', collection);
		}

		if (vintage === 'all') {
			url.searchParams.delete('vintage');
		} else {
			url.searchParams.set('vintage', vintage);
		}

		// Update URL without page reload
		window.history.pushState({}, '', url);
	}

	// Function to apply filters (extracted for reuse)
	function applyFilters(selectedCollection, selectedVintage) {
		$(".col-wine").show(); // Show all items first
		$(".col-none").addClass("d-none");
		let hideCount = 0;

		// Filter based on selections
		$(".col-wine").each(function() {
			const wineCollection = $(this).data("collection");
			const wineVintage = String($(this).data("vintage"));
			let shouldHide = false;

			// Check collection filter
			if (selectedCollection !== "all" && wineCollection !== selectedCollection) {
				shouldHide = true;
			}

			// Check vintage filter
			if (selectedVintage !== "all" && wineVintage !== selectedVintage) {
				shouldHide = true;
			}

			// Hide if doesn't match filters
			if (shouldHide) {
				hideCount++;
				$(this).hide();
			}
		});

		if (hideCount === $(".col-wine").length) {
			$(".reset-filters-col").removeClass("d-none");
			$(".col-none").removeClass("d-none");
			return;
		}

		if (hideCount > 0) {
			$(".col-none").addClass("d-none");
			$(".reset-filters-col").removeClass("d-none");
		} else {
			$(".col-none").addClass("d-none");
			$(".reset-filters-col").addClass("d-none");
		}
	}

	// Set filters from URL on page load
	function initializeFromUrl() {
		const params = getUrlParams();
		$("#collection-filter").val(params.collection);
		$("#vintage-filter").val(params.vintage);

		// Apply filters if any are set
		if (params.collection !== 'all' || params.vintage !== 'all') {
			applyFilters(params.collection, params.vintage);
		}
	}

	// Filter button click event
	$("#filter-button").on("click", function(e) {
		e.preventDefault();
		// Get selected filter values
		const selectedCollection = $("#collection-filter").val();
		const selectedVintage = $("#vintage-filter").val();
		updateUrlParams(selectedCollection, selectedVintage); // Update URL parameters
		applyFilters(selectedCollection, selectedVintage); // Apply filters
		$(".col-wine").addClass("loaded"); // Mark all wines as loaded
	});

	// Reset filters button
	$("#reset-filters-button").on("click", function(e) {
		$("#collection-filter").val("all");
		$("#vintage-filter").val("all");
		$(".col-wine").show();
		$(".reset-filters-col").addClass("d-none");
		$(".col-none").addClass("d-none");
		updateUrlParams('all', 'all'); // Clear URL parameters
	});

	initializeFromUrl();
}();
